import script from "./html-report-content.vue?vue&type=script&setup=true&lang=js"
export * from "./html-report-content.vue?vue&type=script&setup=true&lang=js"

import "./html-report-content.vue?vue&type=style&index=0&id=4654fb74&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4654fb74"]])

export default __exports__